import { render, staticRenderFns } from "./TabUsers.vue?vue&type=template&id=f3049a46"
import script from "./TabUsers.vue?vue&type=script&lang=ts"
export * from "./TabUsers.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports